// src/utils/layout/oleHandler.js
//
// OLE (Excel) async mesh olusturma ve content group'a ekleme.

import { generateYuklemeCetveliXlsx, adaptYCDataToXlsx, generateTopraklamaHesabiXlsx } from '../generators/xlsx';
import { createOLE2FrameMeshFromXlsx } from '../../../utils/createOLE2FrameMeshFromXlsx';
import { PROJECT_TYPES } from '../../../constants/projectTypes';
import { HEADER_HEIGHT } from './layoutConstants';

export function createOlePendingPromise(docContentJson, docDef, documentGroup, projectType) {
  const ycPending = docContentJson?._yukCetveliOlePending;
  const tprPending = docContentJson?._topraklamaHesabiOlePending;
  if (!ycPending && !tprPending) return null;

  const pending = ycPending || tprPending;
  let ycTemplateName = 'yuklemeCetveli';
  if (projectType === PROJECT_TYPES.SINGLE_UNIT) ycTemplateName = 'yuklemeCetveliSingleUnit';
  else if (projectType === PROJECT_TYPES.MULTI_METER) ycTemplateName = 'yuklemeCetveliMultiMeter';

  const generator = ycPending
    ? () => generateYuklemeCetveliXlsx(adaptYCDataToXlsx(pending.data), { templateName: ycTemplateName })
    : () => generateTopraklamaHesabiXlsx(pending.data || {});
  const tag = ycPending ? 'YC' : 'TopraklamaHesabi';
  const capturedDocDef = docDef;
  const capturedGroup = documentGroup;
  const capturedHasFrame = docDef.hasFrame !== false;

  return (async () => {
    try {
      const xlsxBytes = await generator();
      const W = pending.width;
      const H = pending.height;
      const oleTopY = capturedHasFrame ? -HEADER_HEIGHT : 0;
      const mesh = await createOLE2FrameMeshFromXlsx({
        xlsxBytes,
        upperLeft: { x: 0, y: oleTopY, z: 0 },
        lowerRight: { x: W, y: -H, z: 0 },
        layerName: '0',
      });
      // contentGroup parent'i documentGroup icinde olmali
      const contentGroup = capturedGroup.children.find(c => c.isGroup) || capturedGroup;
      // Race guard: bu promise (xlsx üretimi + async texture) beklerken yeni bir
      // rebuild olduysa capturedGroup dispose edilmiş olabilir (disposeMainFrame
      // userData.disposed işaretler). Mesh'i (dev ~4096px texture'ıyla) ölü gruba
      // ekleyip orphan bırakma — bunun yerine mesh'i dispose et.
      if (capturedGroup.userData?.disposed || contentGroup.userData?.disposed) {
        mesh.traverse(o => {
          if (o.geometry) o.geometry.dispose();
          if (o.material) {
            const ms = Array.isArray(o.material) ? o.material : [o.material];
            ms.forEach(m => { if (m.map) m.map.dispose(); m.dispose(); });
          }
        });
        return null;
      }
      contentGroup.add(mesh);
      const meshH = mesh.userData?.oleHeight || 0;
      const totalH = meshH + (capturedHasFrame ? HEADER_HEIGHT : 0);
      return { docDef: capturedDocDef, group: capturedGroup, actualH: totalH };
    } catch (err) {
      console.error(`[${tag} OLE] uretim hatasi:`, err);
      return null;
    }
  })();
}
